<template>
  <div>
    <div class="mt-4">
      <div class="mb-3">
        <p class="text-primary-yellow font-semibold">
          <span v-if="edit">Intra State</span>
          <span v-else>Coverage Details</span>
        </p>
      </div>

      <div class="container-fluid mb-4">
        <div
          class="routes-container row flex flex-nowrap overflow-hidden max-h-screen transition-all duration-500 pr-2"
          v-for="(route, index) in routes"
          :key="route"
          ref="route"
        >
          <img
            class="cursor-pointer mr-2"
            :class="[routes.length > 1 ? 'opacity-100' : 'opacity-25']"
            @click="removeRoute(index)"
            src="@/assets/images/icons/delete-icon.svg"
            alt=""
          />
          <div class="col-md-4 col-lg-4 col-sm-6 col-12">
            <label class="label">State</label>
            <el-select
              filterable
              v-model="takeOffLocation"
              placeholder="Select"
            >
              <el-option
                v-for="state in states"
                :key="state.id"
                :label="state.name"
                :value="state.name"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-4 col-lg-4 col-sm-6 col-12">
            <label class="label">Start</label>
            <el-select filterable v-model="route.start" placeholder="Select">
              <el-option
                v-for="state in cities"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-4 col-lg-4 col-sm-6 col-12">
            <label class="label">Terminate</label>
            <el-select filterable v-model="route.terminal" placeholder="Select">
              <el-option
                v-for="state in cities"
                :key="state"
                :label="state"
                :value="state"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex justify-end">
          <button
            @click="addRoute"
            class="flex w-auto justify-center items-center font-semibold text-primary-yellow"
          >
            <img
              src="@/assets/images/icons/add.svg"
              alt="add icon"
              class="mr-2"
            />
            Add another
          </button>
        </div>
      </div>
    </div>

    <div class="button-wrapper ">
      <p class="cursor-pointer" @click="$router.push({ name: 'Routes' })">
        Cancel
      </p>
      <base-button text="Create Route" v-if="!edit" @click="createRoute" />

      <base-button text="Update Route" v-else @click="updateRoute" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    states: {
      type: Array,
      default: () => [],
    },

    edit: {
      type: Boolean,
      default: false,
    },
    route: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      routeName: "",
      routeMedium: "",
      state: null,
      cities: [],
      filteredCities: [],
      terminal: null,
      locations: [],
      takeOffLocation: "",
      routes: [
        {
          start: "",
          terminal: "",
        },
      ],
    };
  },
  mounted() {
    this.getAllLocations();
    console.log(this.states);
  },
  methods: {
    async getAllLocations() {
      this.locations = [];
      try {
        let response = await this.$_getAll3plLocations();
        this.locations = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },

    addTripBreak() {
      this.routeTripBreaks.push({
        break: "",
      });
    },
    addRoute() {
      let route = {
        state: "",
        start: "",
        terminal: "",
      };
      this.routes.push(route);
      this.cities.push([]);
    },
    removeRoute(val) {
      if (this.routes.length <= 1) return;
      this.$refs.route[val].classList.add("max-h-zero");
      setTimeout(() => {
        this.routes = this.routes.filter((item, index) => index != val);
      }, 500);
    },
    removeTripBreak(index) {
      this.routeTripBreaks.splice(index, 1);
    },

    async createRoute() {
      try {
        await this.$_createRoute(this.payload);
        this.$router.push({ name: "Routes" });
      } catch (error) {
        this.handleError(error);
      }
    },

    async updateRoute() {
      try {
        await this.$_updateRoute(this.payload, this.route.id);
        this.$router.push({ name: "Routes" });
      } catch (error) {
        this.handleError(error);
      }
    },
  },

  computed: {
    payload() {
      return {
        payload: {
          orgName: this.$store.state.authentication.organizationDetails
            .companyname,
          isPrimary: true,
          orgId : localStorage.getItem("organizationId"),
          isSecondary: false,
          isIntrastate: false,
          isInternational: false,
          isInterstate: true,
          takeOffLocation: this.takeOffLocation,
          arrivalLocation: this.takeOffLocation,
          cities: this.routes,
        },
      };
    },

    // referenceTerminals() {
    //   return this.locations.filter((location) => location.state === this.state);
    // },
  },

  watch: {
    state: {
      handler(val) {
        this.filteredCities = [];
        if (val?.length > 0) {
          this.filteredCities = [
            ...this.states.find((state) => state.name == val).cities,
          ];
        }
      },
    },
    route: {
      deep: true,
      immediate: true,
      handler(route) {
        if (route) {
          (this.routeName = route.routeName),
            (this.routeMedium = route.shippingMethod),
            (this.state = route.state),
            (this.cities = route.cities);
          this.terminal = route.referenceTerminal;
        }
      },
    },
    takeOffLocation: {
      deep: true,
      immediate: true,
      handler(val) {
        let stateCities = [];
        if (val != "") {
          stateCities = [...this.states].filter((elem) => val == elem.name)[0]
            .cities;
          this.cities = stateCities;
        } else this.cities = [];
      },
    },
  },
};
</script>

<style>
.max-h-zero {
  max-height: 0;
}
.routes-container {
  animation: 3s 1 linear pop-height;
}
@keyframes pop-height {
  from {
    max-height: 0;
  }
  to {
    max-height: 100vh;
  }
}
</style>
